import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const Profile = () => {
  const { user, updateProfile } = useAuth();
  const [formData, setFormData] = useState({
    username: user?.username || '',
    bio: user?.bio || '',
    profilePicture: user?.profilePicture || ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await updateProfile(formData);
      
      if (result.success) {
        toast.success('Profile updated successfully!');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Failed to update profile');
      console.error('Error updating profile:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h2 className="text-center mb-4">Profile Settings</h2>
      
      <div className="card">
        <div className="mb-4">
          <h3>Account Information</h3>
          <p><strong>Email:</strong> {user?.email}</p>
          <p><strong>Member since:</strong> {new Date(user?.createdAt).toLocaleDateString()}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              className="form-control"
              value={formData.username}
              onChange={handleChange}
              required
              minLength="3"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="bio">Bio</label>
            <textarea
              id="bio"
              name="bio"
              className="form-control"
              value={formData.bio}
              onChange={handleChange}
              rows="4"
              maxLength="500"
              placeholder="Tell us about yourself..."
            />
            <small className="text-muted">
              {formData.bio.length}/500 characters
            </small>
          </div>
          
          <div className="form-group">
            <label htmlFor="profilePicture">Profile Picture URL</label>
            <input
              type="url"
              id="profilePicture"
              name="profilePicture"
              className="form-control"
              value={formData.profilePicture}
              onChange={handleChange}
              placeholder="https://example.com/image.jpg"
            />
            <small className="text-muted">
              Enter a URL for your profile picture
            </small>
          </div>
          
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Profile'}
          </button>
        </form>
      </div>

      <div className="card mt-4">
        <h3>Account Statistics</h3>
        <div className="row">
          <div className="col-md-4 text-center">
            <h4>Posts</h4>
            <p className="text-muted">Coming soon...</p>
          </div>
          <div className="col-md-4 text-center">
            <h4>Comments</h4>
            <p className="text-muted">Coming soon...</p>
          </div>
          <div className="col-md-4 text-center">
            <h4>Likes</h4>
            <p className="text-muted">Coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile; 